import React from 'react'
import MaterialSymbol from '../material-symbol'

const Cached = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="cached" {...props} />
))

Cached.displayName = 'Cached'

export default Cached
